import React, { FunctionComponent, useEffect } from "react";
import styles from "./SportEventsWidget.module.scss";
import SportEventWidgetProps from "./SportEventsWidget.interface";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const SportEventsWidget: FunctionComponent<SportEventWidgetProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const { inViewElementRef, inViewClasses } = setInViewClasses(styles);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    useEffect(() => {
        let newScript: HTMLScriptElement | null = null;
        
        async function fetchWidget() {
            let response = await fetch(props.content.sportEventsRequestUrl);
            if (response.status === 200) {
                let htmlContent = await response.text();
                const scEventsElement = document.getElementById("sc_events");

                if (scEventsElement) {
                    scEventsElement.innerHTML = htmlContent;

                    let scriptTag = scEventsElement.getElementsByTagName("script")[0];
                    if (scriptTag) {
                        let newScript = document.createElement("script");
                        newScript.type = "text/javascript";
                        newScript.src = scriptTag.src;

                        document.head.appendChild(newScript);
                    }
                }
            }
        }

        fetchWidget();

        // Cleanup effect
        return () => {
            if (newScript) {
                document.head.removeChild(newScript);
            }

            const scEventsElement = document.getElementById("sc_events");
            if (scEventsElement) {
                scEventsElement.innerHTML = "";
            }
        };
    }, []);

    return (
        <section
            className={combineClasses(styles.wrapper, inViewClasses, ...wrapperClasses)}
            style={{ ...wrapperStyles, ...splitStyles }}
            ref={inViewElementRef}
        >
            <div className={combineClasses(styles.container, ...splitClasses)}>
                <div className={styles.content}>
                    <div id="sc_events"></div>
                </div>
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia
                    key={props.contentUdi}
                    {...props.settings.backgroundMedia[0]}
                />
            ) : null}
        </section>
    );
};

export default SportEventsWidget;
